<div class="download_btn" (click)="show()">
    {{ TEXTS.EDIT_STATION.downloadXLSData }}
</div>
